import * as Yup from 'yup'

export const completeRegistrationVerifySchema = Yup.object().shape({
  code: Yup.string().required('Campo obrigatório').min(5, 'O código deve ter 5 dígitos'),
})
